// extracted by mini-css-extract-plugin
module.exports = {"logo":"AdminLogo_logo__3fvUQ","black":"AdminLogo_black__KSpS7"};